import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

const PublicRoute = ({ component, ...rest }) => (
  <Route {...rest} render={routeProps => renderMergedProps(component, routeProps, rest)} />
);
PublicRoute.propTypes = { component: PropTypes.func.isRequired };

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/containers/PublicRoute.js